import { DEFAULT_PAGE_SIZE } from '@/common/components/constants';
import { InputType } from '../components/shared/CustomForm/CustomForm.types';
import { SectionName } from '../components/shared/ManualForm/ManualForm.types';
import {
  AvailableDates,
  AvailableTimeRanges,
  CHANGE_TYPE,
  CompletedReferral,
  DeclinedReferral,
  HISTORY_EVENTS,
  PatientHistory,
  PatientProfileResponse,
  PendingReferral,
  ReferralListItem,
  ReferralsResponse,
  ReferralStatuses,
  UpcomingReferral,
} from '../types';

const MOCK_REFERRALS_LIST: Array<UpcomingReferral | DeclinedReferral | CompletedReferral | PendingReferral> = [
  {
    appointmentID: '1',
    referralDateTime: '2023-07-14T00:00:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Chuck',
    lastName: 'Norris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.PENDING,
  },
  {
    appointmentID: '2',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.PENDING,
  },
  {
    appointmentID: '3',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.PENDING,
  },
  {
    appointmentID: '4',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:00:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Chuck',
    lastName: 'Norris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.UPCOMING,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '5',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.UPCOMING,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '6',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.UPCOMING,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '7',
    completionDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Chuck',
    lastName: 'Norris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DELIVERED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '8',
    completionDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DELIVERED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '9',
    completionDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.NO_SHOW,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '10',
    completionDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DELIVERED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '11',
    completionDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DELIVERED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '12',
    declinedDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Chuck',
    lastName: 'Norris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DECLINED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '13',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.PENDING,
  },
  {
    appointmentID: '14',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.PENDING,
  },
  {
    appointmentID: '15',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.PENDING,
  },
  {
    appointmentID: '16',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.UPCOMING,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '17',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.UPCOMING,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '18',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.UPCOMING,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '19',
    completionDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DELIVERED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '20',
    completionDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.NO_SHOW,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '21',
    completionDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DELIVERED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '22',
    completionDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DELIVERED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '23',
    completionDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.NO_SHOW,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '24',
    declinedDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DECLINED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '24',
    declinedDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DECLINED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '24',
    declinedDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DECLINED,
    timeZone: 'America/Los_Angeles',
  },
  {
    appointmentID: '24',
    declinedDateTime: '2023-07-14T13:00:00.000',
    appointmentEndTime: '2023-07-14T13:30:00.000',
    appointmentStartTime: '2023-07-14T13:30:00.000',
    dateOfBirth: '1988-04-22',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '223-434-9488',
    status: ReferralStatuses.DECLINED,
    timeZone: 'America/Los_Angeles',
  },
];

export const MOCK_REFERRALS: ReferralsResponse<ReferralListItem> | any = {
  data: MOCK_REFERRALS_LIST,
  page: 1,
  size: DEFAULT_PAGE_SIZE,
  totalCount: MOCK_REFERRALS_LIST.length,
};

export const MOCK_REFERRALS_NO_RESULTS: ReferralsResponse<ReferralListItem> | any = {
  data: [],
  page: 1,
  size: DEFAULT_PAGE_SIZE,
  totalCount: 0,
};

export const MOCK_PATIENT_HISTORY: PatientHistory[] = [
  {
    appointmentHistoryID: '1',
    appointmentID: '16249',
    changeType: '',
    curAppointmentEndTime: '2022-10-08T22:30:00Z',
    curAppointmentID: '',
    curAppointmentStartTime: '2022-10-08T22:00:00Z',
    curAppointmentTimezone: '',
    curChange: '',
    declineNote: '',
    declineReasonCode: 'Not interested in genetic counseling',
    event: HISTORY_EVENTS.DECLINE,
    eventTimestamp: '2022-04-08T22:05:56Z',
    interpretationID: '',
    performer: 'Elisa Doe',
    prevAppointmentEndTime: '',
    prevAppointmentID: '',
    prevAppointmentStartTime: '',
    prevAppointmentTimezone: '',
    prevChange: '',
    sourceID: 'SI-EXT7-G9TCY',
    userID: '00ubqwg0iqu2xmVgH1d7',
  },
  {
    appointmentHistoryID: '1',
    appointmentID: '16249',
    changeType: '',
    curAppointmentEndTime: '2022-10-08T22:30:00Z',
    curAppointmentID: '',
    curAppointmentStartTime: '2022-10-08T22:00:00Z',
    curAppointmentTimezone: '',
    curChange: '',
    declineNote: '',
    declineReasonCode: '',
    event: HISTORY_EVENTS.COMPLETED,
    eventTimestamp: '2022-04-08T22:05:56Z',
    interpretationID: '',
    performer: 'John Doe',
    prevAppointmentEndTime: '',
    prevAppointmentID: '',
    prevAppointmentStartTime: '',
    prevAppointmentTimezone: '',
    prevChange: '',
    sourceID: 'SI-EXT7-G9TCY',
    userID: '00ubqwg0iqu2xmVgH1d7',
  },
  {
    appointmentHistoryID: '1',
    appointmentID: '16249',
    changeType: '',
    curAppointmentEndTime: '2022-10-08T22:30:00Z',
    curAppointmentID: '',
    curAppointmentStartTime: '2022-10-08T22:00:00Z',
    curAppointmentTimezone: '',
    curChange: '',
    declineNote: '',
    declineReasonCode: '',
    event: HISTORY_EVENTS.REOPEN,
    eventTimestamp: '2022-04-08T22:05:56Z',
    interpretationID: '',
    performer: 'John Doe',
    prevAppointmentEndTime: '',
    prevAppointmentID: '',
    prevAppointmentStartTime: '',
    prevAppointmentTimezone: '',
    prevChange: '',
    sourceID: 'SI-EXT7-G9TCY',
    userID: '00ubqwg0iqu2xmVgH1d7',
  },
  {
    appointmentHistoryID: '1',
    appointmentID: '16249',
    changeType: '',
    curAppointmentEndTime: '2022-10-08T22:30:00Z',
    curAppointmentID: '',
    curAppointmentStartTime: '2022-10-08T22:00:00Z',
    curAppointmentTimezone: '',
    curChange: '',
    declineNote: '',
    declineReasonCode: '',
    event: HISTORY_EVENTS.CANCEL,
    eventTimestamp: '2022-04-08T22:05:56Z',
    interpretationID: '',
    performer: 'Elisa Doe',
    prevAppointmentEndTime: '',
    prevAppointmentID: '',
    prevAppointmentStartTime: '',
    prevAppointmentTimezone: '',
    prevChange: '',
    sourceID: 'SI-EXT7-G9TCY',
    userID: '00ubqwg0iqu2xmVgH1d7',
  },
  {
    appointmentHistoryID: '1',
    appointmentID: '16249',
    changeType: CHANGE_TYPE.PHONE,
    curAppointmentEndTime: '',
    curAppointmentID: '',
    curAppointmentStartTime: '',
    curAppointmentTimezone: '',
    curChange: '529-310-4871',
    declineNote: '',
    declineReasonCode: '',
    event: HISTORY_EVENTS.UPDATE,
    eventTimestamp: '2022-02-08T22:05:56Z',
    interpretationID: '',
    performer: 'Test performer',
    prevAppointmentEndTime: '',
    prevAppointmentID: '',
    prevAppointmentStartTime: '',
    prevAppointmentTimezone: '',
    prevChange: '529-310-6666',
    sourceID: 'SI-EXT7-G9TCY',
    userID: '00ubqwg0iqu2xmVgH1d7',
  },
  {
    appointmentHistoryID: '1',
    appointmentID: '16249',
    changeType: 'email',
    curAppointmentEndTime: '',
    curAppointmentID: '',
    curAppointmentStartTime: '',
    curAppointmentTimezone: '',
    curChange: 'genetic-counseling-test+7419683@helix.com',
    declineNote: '',
    declineReasonCode: '',
    event: HISTORY_EVENTS.UPDATE,
    eventTimestamp: '2022-02-08T22:05:56Z',
    interpretationID: '',
    performer: 'Test performer',
    prevAppointmentEndTime: '',
    prevAppointmentID: '',
    prevAppointmentStartTime: '',
    prevAppointmentTimezone: '',
    prevChange: 'genetic-counselingaaa@helix.com',
    sourceID: 'SI-EXT7-G9TCY',
    userID: '00ubqwg0iqu2xmVgH1d7',
  },
  {
    appointmentHistoryID: '1',
    appointmentID: '16249',
    changeType: '',
    curAppointmentEndTime: '',
    curAppointmentID: '',
    curAppointmentStartTime: '',
    curAppointmentTimezone: '',
    curChange: '',
    declineNote: '',
    declineReasonCode: '',
    event: HISTORY_EVENTS.VIEWED,
    eventTimestamp: '2022-02-08T22:05:56Z',
    interpretationID: '',
    performer: 'Christina Yang',
    prevAppointmentEndTime: '',
    prevAppointmentID: '',
    prevAppointmentStartTime: '',
    prevAppointmentTimezone: '',
    prevChange: '',
    sourceID: 'SI-EXT7-G9TCY',
    userID: '00ubqwg0iqu2xmVgH1d7',
  },
  {
    appointmentHistoryID: '1',
    appointmentID: '16249',
    changeType: '',
    curAppointmentEndTime: '2022-10-08T22:30:00Z',
    curAppointmentID: '',
    curAppointmentStartTime: '2022-10-08T22:00:00Z',
    curAppointmentTimezone: '',
    curChange: '',
    declineNote: '',
    declineReasonCode: '',
    event: HISTORY_EVENTS.RESCHEDULE,
    eventTimestamp: '2022-02-08T22:05:56Z',
    interpretationID: '',
    performer: 'Christina Yang',
    prevAppointmentEndTime: '2022-09-08T22:30:00Z',
    prevAppointmentID: '',
    prevAppointmentStartTime: '2022-09-08T22:00:00Z',
    prevAppointmentTimezone: '',
    prevChange: '',
    sourceID: 'SI-EXT7-G9TCY',
    userID: '00ubqwg0iqu2xmVgH1d7',
  },
  {
    appointmentHistoryID: '1',
    appointmentID: '16249',
    changeType: '',
    curAppointmentEndTime: '2022-09-08T22:30:00Z',
    curAppointmentID: '',
    curAppointmentStartTime: '2022-09-08T22:00:00Z',
    curAppointmentTimezone: '',
    curChange: '',
    declineNote: '',
    declineReasonCode: '',
    event: HISTORY_EVENTS.SCHEDULE,
    eventTimestamp: '2022-02-08T22:05:56Z',
    interpretationID: '',
    performer: 'Christina Yang',
    prevAppointmentEndTime: '',
    prevAppointmentID: '',
    prevAppointmentStartTime: '',
    prevAppointmentTimezone: '',
    prevChange: '',
    sourceID: 'SI-EXT7-G9TCY',
    userID: '00ubqwg0iqu2xmVgH1d7',
  },
  {
    appointmentHistoryID: '1',
    appointmentID: '16249',
    changeType: '',
    curAppointmentEndTime: '2022-09-08T22:30:00Z',
    curAppointmentID: '',
    curAppointmentStartTime: '2022-09-08T22:00:00Z',
    curAppointmentTimezone: '',
    curChange: '',
    declineNote: '',
    declineReasonCode: '',
    event: HISTORY_EVENTS.CREATE,
    eventTimestamp: '2022-01-08T22:05:56Z',
    interpretationID: '',
    performer: 'Christina Yang',
    prevAppointmentEndTime: '',
    prevAppointmentID: '',
    prevAppointmentStartTime: '',
    prevAppointmentTimezone: '',
    prevChange: '',
    sourceID: 'SI-EXT7-G9TCY',
    userID: '00ubqwg0iqu2xmVgH1d7',
  },
];

export const MOCK_PATIENT_PROFILE_RESPONSE: PatientProfileResponse = {
  appointment: {
    appointmentID: '12345',
    appointmentStartTime: '2023-08-02T20:00:00Z',
    appointmentEndTime: '2023-08-02T20:30:00Z',
    appointmentType: 'Genetic Counseling',
    declinedDatetimeTime: '2023-08-02T16:00:00Z',
    completionDateTime: '2023-08-03T21:00:00Z',
    timeZone: 'America/Los_Angeles',
    declinedReasonCode: '',
    declinedReasonNotes: 'declinedNotes',
    reasonCode: 'reasonCode',
  },
  orderID: '0101010101',
  userID: 'mock-userID',
  patientProfile: {
    dateOfBirth: '1980-12-18',
    email: 'luke.skywalker@gmail.com',
    firstName: 'Luke',
    lastName: 'Skywalker',
    patientID: 'SI-TEST-SMART MRN^1231234567',
    phoneNumber: '123-456-7890',
    sexAtBirth: 'Male',
  },
  serviceDetails: {
    service: 'Genetic Counseling - 30 min',
    serviceID: '0',
    specialty: 'General Health and Wellness',
    specialtyID: '9',
    subSpecialty: 'Discuss Genetic Testing Already Performed',
    subSpecialtyID: '10',
  },
  status: ReferralStatuses.UPCOMING,
};

export const DEFAULT_PATIENT_PROFILE_RESPONSE: PatientProfileResponse = {
  appointment: {
    appointmentID: '',
    appointmentStartTime: '',
    appointmentEndTime: '',
    appointmentType: '',
    declinedReasonCode: '',
    declinedDatetimeTime: '',
    completionDateTime: '',
    timeZone: 'America/Los_Angeles',
    declinedReasonNotes: '',
    reasonCode: '',
  },
  orderID: '',
  userID: 'mock-userID',
  patientProfile: {
    dateOfBirth: '',
    email: '',
    sexAtBirth: '',
    lastName: '',
    firstName: '',
    patientID: '',
    phoneNumber: '',
  },
  serviceDetails: {
    service: '',
    serviceID: '',
    specialty: '',
    specialtyID: '',
    subSpecialty: '',
    subSpecialtyID: '',
  },
  status: ReferralStatuses.PENDING,
};

export const MOCK_CUSTOM_FORM_INPUT = [
  {
    id: SectionName.INFO,
    name: 'Name',
    required: true,
    section: SectionName.INFO,
    target: 'John',
    type: InputType.TEXT,
  },
];

export const MOCK_CUSTOM_FORM_SELECT = [
  {
    id: SectionName.SERVICE,
    name: 'Service',
    options: [
      {
        id: 'genetic-counseling',
        label: 'Genetic Counseling - 15 min',
      },
    ],
    required: true,
    section: SectionName.SERVICE,
    target: 'genetic-counseling',
    type: 'select',
  },
];

export const MOCK_AVAILABLE_DATES: AvailableDates = {
  availableDates: ['2023-09-04', '2023-09-12', '2023-09-14', '2023-09-19', '2023-09-20', '2023-09-25', '2023-09-27'],
};

export const MOCK_AVAILABLE_TIME_RANGES: AvailableTimeRanges = {
  availableDatetimes: [
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T08:00:00-0500',
      endTime: '2023-08-04T08:30:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T08:30:00-0500',
      endTime: '2023-08-04T09:00:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T09:00:00-0500',
      endTime: '2023-08-04T09:30:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T09:30:00-0500',
      endTime: '2023-08-04T10:00:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T10:30:00-0500',
      endTime: '2023-08-04T11:00:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T10:00:00-0500',
      endTime: '2023-08-04T10:30:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T11:00:00-0500',
      endTime: '2023-08-04T11:30:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T12:00:00-0500',
      endTime: '2023-08-04T12:30:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T12:30:00-0500',
      endTime: '2023-08-04T13:00:00.000-05:00',
    },

    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T11:30:00-0500',
      endTime: '2023-08-04T12:00:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T13:00:00-0500',
      endTime: '2023-08-04T13:30:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T13:30:00-0500',
      endTime: '2023-08-04T14:00:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T14:00:00-0500',
      endTime: '2023-08-04T14:30:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T14:30:00-0500',
      endTime: '2023-08-04T15:00:00.000-05:00',
    },
    {
      appointmentTypeID: 0,
      geneticCounselorProfile: {
        firstName: 'FirstName',
        lastName: 'LastName',
        id: 0,
      },
      duration: 30,
      startTime: '2023-08-04T15:00:00-0500',
      endTime: '2023-08-04T15:30:00.000-05:00',
    },
  ],
};

export const MOCK_FIND_PATIENT_ID_RESPONSE: PatientProfileResponse = {
  appointment: {
    appointmentID: '12345',
    appointmentStartTime: '2023-08-02T20:00:00Z',
    appointmentEndTime: '2023-08-02T20:30:00Z',
    appointmentType: 'Genetic Counseling',
    declinedDatetimeTime: '2023-08-02T16:00:00Z',
    completionDateTime: '2023-08-03T21:00:00Z',
    timeZone: 'America/Los_Angeles',
    declinedReasonCode: '',
    declinedReasonNotes: '',
    reasonCode: '',
  },
  orderID: '123123',
  userID: 'mock-userID',
  patientProfile: {
    dateOfBirth: '10-21-1978',
    email: 'johndoe@example.com',
    firstName: 'Joe',
    lastName: 'Morris',
    patientID: '74612494',
    phoneNumber: '(125) 236-5546',
    sexAtBirth: 'Male',
  },
  serviceDetails: {
    service: 'Genetic Counseling - 30 min',
    serviceID: '0',
    specialty: 'General Health and Wellness',
    specialtyID: '9',
    subSpecialty: 'Discuss Genetic Testing Already Performed',
    subSpecialtyID: '10',
  },
};
